export default class PatternRegex {
  public static readonly ONLY_NUMBERS_REGEX_G = /[^\d]/g

  public static readonly ONLY_LETTERS_SPACES_REGEX = /^[A-Za-zÀ-ÿ\s]+$/g

  public static readonly REPEATABLE_NUMBERS_REGEX = /^([0-9])\1*$/

  public static readonly CENTS_REGEX = /(\d)(\d{2})$/

  public static readonly VALID_EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

  public static readonly VALID_UUID_REGEX =
    /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

  public static readonly PHONE_PIX_FORMAT_REGEX = /[ ()-]/g

  public static readonly USER_NAME_FORMAT_REGEX =
    /^(?=.{3,})([A-Za-zÀ-ÿ’'-]{2,})(?: (?=.{2,})([A-Za-zÀ-ÿ’'-]{1,}))*$/

  public static readonly BRT_DATE_REGEX = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/

  public static readonly SAFE_BREADCRUMB_NAME = /\s+/g

  private constructor() {}

  public static getOnlyNumbers(value?: string): string {
    if (!value) return ''
    return value.replace(PatternRegex.ONLY_NUMBERS_REGEX_G, '')
  }

  public static isRepeatableNumbers(value: string): boolean {
    return PatternRegex.REPEATABLE_NUMBERS_REGEX.test(value)
  }

  public static centsToNumber = (digits: string): number => {
    return Number(digits.replace(PatternRegex.CENTS_REGEX, '$1.$2'))
  }

  public static toUrlSafeBreadcrumbName(name: string): string {
    return name.toLowerCase().replace(PatternRegex.SAFE_BREADCRUMB_NAME, '_')
  }
}
